export const LOADING_CELL_TEXT = "Loading..."

export interface RowUnit {
  currencyScale: string
  currency?: string | null
}
